<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row my-profile-form">



  <div class="columninvoice margin-top-17px">
    <div class="card height-100vh ">
      <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px ">
        <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-5 padding-right-0px">
                <label class="margin-bottom-0px margin-left-5px">New Goods Inward</label>
              </div>
              <div class="col-md-3 padding-left-0px">
                <label class="margin-bottom-0px font-size-14">Receiving Store</label>
              </div>:
              <div class="col-md-3 padding-left-5px padding-right-7px">
                <label class="margin-bottom-0px font-size-16px color-Assign">{{PurchaseInvoiceData.OwnerStoreName}}</label>
                <!--<CustomDataByRequestType RequestedType="AccessibleStores" FacilityCode={{FacilityCode}} ActorCode={{ActorCode2}} class="form-group margin-bottom-0px" SelectedValue="StoreCode"
                                         [(ngModel)]="PurchaseInvoiceData.OwnerStore" (keyChange)="onAssignedShipToLocationname($event)"
                                         name="ShipToLocationname" #sign2="ngModel">
                </CustomDataByRequestType>-->

              </div>

            </div>


            <!--<label *ngIf="StoreCode==0 && Prescribercode==0" class="color-Assign font-size-14">(Select Store & Prescriber)</label>-->
            <!--<label *ngIf="Prescribercode==0" class="color-Assign font-size-14">(Select Store)</label>-->
          </div>


          <div class="col-md-6 float-right">
            <div class="row">              
              <div class="offset-md-4 col-md-8 padding-left-0px">
                <button type="button"
                        class="btn btn-secondary float-right  font-size-13px margin-left-5px btn-raised button-Schedule actions-btn-prime actions-btn-prime3"
                        (click)="Cancel()">Back</button>                
                <div>
                  <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                          (click)="SaveData()" *ngIf='isvisible'>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                </div>
                
              </div>
              
            </div>
          </div>

        </div>
        <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">

        </div>
      </div>
      <div class="card-body  padding-bottom-0px padding-left-0px padding-right-0px padding-top-0px margin-left-10px">




        <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt height-80pe">
          <div class="row margin-left-2px">
            <div class="col-md-12  padding-right-0px padding-left-9px">
              <div id="items">
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExampleone">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Invoice Details
                              </button>
                            </h5>
                          </div>

                        </div>


                      </div>

                      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExampleone">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Vendor Code </label>
                                    </div>:
                                    <div class="col-md-5">

                                      <h4 class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold font-size-16px">
                                        {{PurchaseInvoiceData.VendorCode}} {{PurchaseInvoiceData.VendorName}}
                                      </h4>

                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Vendor Document Ref </label>
                                    </div>:
                                    <div class="col-md-5">

                                      <textarea class="form-control3 size-2 width-inherit"
                                                rows="2" placeholder="Vendor Document Ref"
                                                name="PurchaseInvoiceData.RefDocNo"
                                                [(ngModel)]="PurchaseInvoiceData.RefDocNo"></textarea>

                                    </div>

                                  </div>

                                </div>
                              </div>
                              <!--<div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Pay Against </label>
                                    </div>:
                                    <div class="col-md-5">

                                      <CodeTypeValue CodeType="PAYAG"
                                                     id="PurchaseInvoiceData.PayAgainst"
                                                     [(ngModel)]="PurchaseInvoiceData.PayAgainst"
                                                     SelectedValue="PurchaseInvoiceData.PayAgainst"
                                                     name="PurchaseInvoiceData.PayAgainst">
                                      </CodeTypeValue>

                                    </div>

                                  </div>

                                </div>
                              </div>-->
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Purchase Order# </label>
                                    </div>:
                                    <div class="col-md-5">

                                      <h4 class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold font-size-16px">
                                        {{PurchaseInvoiceData.PurchaseOrderCode}}
                                      </h4>

                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Invoice Code </label>
                                    </div>:
                                    <div class="col-md-5">

                                      <h4 class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold font-size-16px">
                                        {{PurchaseInvoiceData.VendorInvoiceCode}}
                                      </h4>

                                    </div>

                                  </div>

                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">GRN Date</label>
                                    </div>

                                    <div class="col-md-5">

                                      <div class="date-form">
                                        <input type="text" class="form-control form-control-patient" placeholder="Date Of Birth"
                                               name="dp" [(ngModel)]="InvoiceDate" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d="ngbDatepicker" #DOBin="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOBin.valid && (DOBin.dirty || DOBin.touched) && DOBin.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>

                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Payment Due Date</label>
                                    </div>

                                    <div class="col-md-5">
                                      <div class="date-form">
                                        <input class="form-control form-control-patient" placeholder="Date Of Birth"
                                               name="dps" [(ngModel)]="PaymentDueDate" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d1fe="ngbDatepicker" #DOBfe="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOBfe.valid && (DOBfe.dirty || DOBfe.touched) && DOBfe.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d1fe.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">Status</label>
                                    </div>
                                    <div class="col-md-5">
                                      <label class="margin-bottom-0px form-control">{{PurchaseInvoiceData.InvoiceStatus}}</label>
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row padding-top-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Delivary Details</label>
                                    </div>

                                    <div class="col-md-7 padding-right-0px">
                                      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Delivary Details"
                                                name="PurchaseInvoiceData.Notes"
                                        [(ngModel)]="PurchaseInvoiceData.Notes"></textarea>


                                    </div>
                                  </div>


                                </div>
                              </div>
                            </div>
                          </div>



                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="row margin-left-2px">
            <div class="col-md-12  padding-right-0px padding-left-9px">
              <div id="items">
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExampleTwo">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                Summary Totals
                              </button>
                            </h5>
                          </div>

                        </div>


                      </div>

                      <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExampleTwo">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                          <div class="row border-top opbill-receipthead-bgclr border-bottom bk-color-light margin-left-0px margin-right-0px">
                            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Branch</label></div>
                              <div><h4 class="margin-bottom-0px font-size-16px color-Assign margin-top-5px">{{BranchName}}</h4></div>
                            </div>
                            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Total Amount</label></div>
                              <div><h4 class="margin-bottom-0px font-size-16px color-Assign margin-top-5px">{{PurchaseInvoiceData.GrossAmount | number:'1.0-2'}}</h4></div>
                            </div>

                            <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="row" hidden>
                                <div class="col-md-5 margin-top-9px padding-right-0px margin-left-10px padding-left-9px">
                                  <label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">
                                    Included Delivary Charges
                                  </label>
                                </div>
                                <div class="col-md-1 padding-left-7px margin-top-12p padding-right-0px">
                                  <input type="checkbox" class="checkbox2" />
                                  <i class="input-helper"></i>
                                </div>
                                <div class="col-md-5 padding-right-0px margin-top-4px">
                                  <input type="text" class="form-control" placeholder="">

                                </div>
                              </div>




                            </div>


                            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Total tax</label></div>
                              <div><h4 class="margin-bottom-0px font-size-16px color-Assign margin-top-5px">{{PurchaseInvoiceData.TaxAmount | number:'1.0-2'}}</h4></div>
                            </div>
                            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Net</label></div>
                              <div><h4 class="margin-bottom-0px font-size-16px color-Assign margin-top-5px">{{PurchaseInvoiceData.NetAmount | number:'1.0-2'}}</h4></div>
                            </div>
                          </div>
                          <!--<div class="row margin-top-5px margin-left-3px">
                            <div class="col-md-3" hidden>

                              <div class="table-component">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">
                                    <caption>Tax Summary</caption>
                                    <tr>


                                      <th class="font-weight-normal td-padding-tb background-primary padding-right-0px">
                                        Tax %
                                      </th>


                                      <th class="font-weight-normal td-padding-tb background-primary padding-right-0px">
                                        Amount
                                      </th>
                                      
                                    </tr>
                                    <tr>

                                      <td class="td-padding-tb text-align-center padding-left-0px padding-right-20px">
                                        <label class="margin-bottom-0px">5</label>

                                      </td>
                                      <td class="td-padding-tb text-align-center padding-left-0px padding-right-20px">
                                        <label class="margin-bottom-0px">4.838</label>
                                      </td>
                                    </tr>

                                    <tr>
                                      <th rowspan="1" class="td-padding-tb background-primary">
                                        Total
                                      </th>
                                      <td class="td-padding-tb font-weight-bold">
                                        <input type="number" class="form-control"
                                        min="1" max="10" id="FollicularPickupEndInfo.TotalOocytes"
                                        [(ngModel)]="FollicularPickupEndInfo.TotalOocytes"
                                        name="FollicularPickupEndInfo.TotalOocytes" #Doctor="ngModel"
                                        required />
                                        <label>0</label>
                                      </td>

                                    </tr>
                                  </table>

                                </div>
                              </div>
                            </div>
                            <div class="col-md-2 mistable-data2">
                              <div class="row margin-left-0px font-size-12px font-weight-bold">
                                &#64; 5%
                              </div>
                              <div class="row margin-left-0px misdatafont">
                                {{CurrentPurchaseOrderHeaderDetailsController.Tax}}
                              </div>
                            </div>
                          </div>-->



                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="row margin-left-2px">
            <div class="col-md-12  padding-right-0px padding-left-9px">
              <div id="items">
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExampleFou">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFou">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFou" aria-expanded="true" aria-controls="collapseFou">
                                Line Items
                              </button>
                            </h5>
                          </div>

                        </div>


                      </div>

                      <div id="collapseFou" class="collapse show" aria-labelledby="headingFou" data-parent="#accordionExampleFou">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row padding-top-3px margin-right-0px">
                            <div class="col-md-12 padding-left-0px padding-right-0px">
                              <div class="table-component">
                                <div class="table-responsive overflow-x">


                                  <table class="table table-striped margin-left-10px table-fixed"
                                         cols="auto,2*,*,*,*,*,*,*">

                                    <thead class="">
                                      <tr>

                                        <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                                          #
                                        </th>


                                        <th class="padding-top-4px padding-right-0px padding-bottom-4px th-sticky padding-left-10px">
                                          Item Description

                                        </th>
                                        <th class="padding-top-4px padding-right-0px padding-bottom-4px th-sticky">
                                          Ord Qty
                                        </th>
                                        <th class="padding-top-4px padding-right-0px padding-bottom-4px th-sticky">
                                          Bonus Qty
                                        </th>
                                        <th class="padding-top-4px padding-right-0px padding-bottom-4px th-sticky">
                                          Total Qty
                                        </th>

                                        <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px th-sticky">
                                          Unit Price
                                        </th>
                                        <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px th-sticky">
                                          Item Total
                                        </th>
                                        <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px th-sticky">
                                          Tax %
                                        </th>
                                        <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px th-sticky">
                                          Tax
                                        </th>
                                        <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px th-sticky">
                                          Item Net
                                        </th>
                                        <th class="padding-top-4px padding-right-0px padding-bottom-4px th-sticky">
                                          Uom
                                        </th>
                                        <th class="padding-top-4px padding-right-0px padding-bottom-4px th-sticky">
                                          Pack
                                        </th>

                                        <th class="padding-top-4px padding-right-0px padding-bottom-4px th-sticky">
                                          Batch
                                        </th>
                                        <th class="padding-top-4px padding-right-0px padding-bottom-4px th-sticky">
                                          Exp.Date
                                        </th>
                                        <th class="padding-top-4px padding-right-0px padding-bottom-4px th-sticky">
                                          Pur Price
                                        </th>
                                        <!--<th class="padding-top-4px padding-bottom-4px th-sticky">
    Sale Price
  </th>-->

                                        <th class="padding-top-4px padding-right-0px padding-bottom-4px th-sticky">
                                          MRP
                                        </th>

                                        <!--<th hidden class="padding-top-4px padding-bottom-4px th-sticky">
                                          Disc %
                                        </th>-->



                                        <th class="">

                                        </th>







                                      </tr>
                                    </thead>

                                    <tbody class="table-body" *ngIf="PurchaseInvoiceData.Items">
                                      <tr *ngFor="let l of PurchaseInvoiceData.Items">


                                        <td class="td-padding-tb">
                                          {{l.ItemCode}}
                                        </td>
                                        <td class=" td-padding-tb">
                                          <div>{{l.ItemDescription}}</div>

                                        </td>
                                        <td class="td-padding-tb">
                                          {{l.Quantity}}
                                        </td>
                                        <td class="td-padding-tb">
                                          {{l.BonusQuantity}}
                                        </td>
                                        <td class="td-padding-tb">
                                          {{l.TotalOrderQuantity}}
                                        </td>
                                        <td class="text-align-center td-padding-tb padding-right-0px">
                                          {{l.UnitPrice | number:'1.0-2'}}
                                        </td>
                                        <td class="text-align-center td-padding-tb padding-right-0px">
                                          {{ (l.Quantity * l.PurchasePrice) | number:'1.0-2'}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px">
                                          {{l.TaxPercent | number:'1.0-2'}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px">
                                          {{l.TaxAmount | number:'1.0-2'}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px">
                                          {{ ((l.Quantity * l.PurchasePrice) + l.TaxAmount) | number:'1.0-2'}}
                                        </td>
                                        <td class="td-padding-tb text-align-center max-width-10pe">
                                          {{l.UOM}}
                                        </td>
                                        <td class="td-padding-tb text-align-center max-width-10pe">
                                          {{l.Pack}}
                                        </td>

                                        <td class="td-padding-tb padding-right-0px padding-top-0px ">
                                          {{l.BatchNo}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px padding-top-0px ">
                                          {{l.ExpiryDate| date:'dd-MMM-yyyy'}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px padding-top-0px ">
                                          {{l.PurchasePrice | number:'1.0-2'}}
                                        </td>
                                        <!--<td class="td-padding-tb padding-right-0px padding-top-0px ">
    {{l.SellingPrice | number:'1.2-2'}}
  </td>-->
                                        <td class="text-align-center td-padding-tb padding-right-0px">
                                          {{l.Mrp | number:'1.0-2'}}
                                        </td>
                                        <!--<td hidden class="text-align-center td-padding-tb padding-right-0px">10</td>-->
                                        <td class=" td-padding-tb text-align-center">

                                          <!--<a class="nav-link-hand education-navlink font-size-16px color-Assign" title="Edit Plan" (click)="Editrow()" *ngIf="Add">
      <span class="badge"><i class="fas fa-pencil-alt"></i></span>
    </a>-->
                                          <!--<button type="submit" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Save"><i class="fas fa-pencil-alt"></i></button>-->
                                          <a (click)="EditItems(PurchaseInvoiceData, l)"
                                             class="nav-link-hand font-size-16px color-secondary margin-right-10px" title="Edit"><i class="fas fa-pencil-alt"></i></a>
                                          <!--<a class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>-->
                                          <!--<button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l.Edit"><i class="far fa-save"></i></button>
    <button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px  nav-link-hand color-Rejected" title="Save" *ngIf="l.Edit"><i class="fa fa-times"></i></button>-->

                                        </td>



                                      </tr>
                                    </tbody>



                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="row margin-left-2px">
            <div class="col-md-12  padding-right-0px padding-left-9px">
              <div id="items">
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExampleThr">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingThr">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseThr" aria-expanded="true" aria-controls="collapseThr">
                                Remarks
                              </button>
                            </h5>
                          </div>

                        </div>


                      </div>

                      <div id="collapseThr" class="collapse show" aria-labelledby="headingThr" data-parent="#accordionExampleThr">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row padding-top-3px">
                            <div class="col-md-11 padding-right-0px margin-left-10px">
                              <textarea class="form-control3 size-2 width-inherit"
                                        rows="3" placeholder="Remarks"
                                        name="PurchaseInvoiceData.Remarks"
                                        [(ngModel)]="PurchaseInvoiceData.Remarks"></textarea></div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>


          <!--<div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div class="card">


                <div class="card-header wh-header border-bottom padding-bottom-0px">
                  <div class="row border-bottom">
                    <div class="col-md-12">
                      <label class="margin-bottom-0px">Payment</label>
                    </div>

                  </div>
                </div>
                <div class="card-body padding-top-5px padding-bottom-0px">
                  <div class="row">

                      <div class="col-md-12 padding-right-0px">
                        <div class="table-component">
                          <div class="table-responsive">


                            <table class="table table-striped margin-left-zero width-100">

                              <thead class="">
                                <tr>

                                  <th class="min-width-0px"></th>
                                  <th class="th-width-170px">Amount</th>

                                  <th class="th-width-170px">Charges</th>
                                  <th class="th-width-170px">Ref.No</th>
                                  <th>Details</th>
                                </tr>
                              </thead>
                              <tbody class="table-body">

                                <tr>
                                  <td class="td-padding">

                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="cash" />
                                      <i class="input-helper"></i>

                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">Cash</label>



                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="card" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Card</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">


                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="cheque" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Cheque</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="demanddraft" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Demand Draft</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="paytm" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Paytm</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">
                                  </td>



                                </tr>
                              </tbody>

                            </table>

                          </div>
                        </div>
                      </div>

                  </div>
                                         </div>






              </div>
            </div>
          </div>-->
        </div>
      </div>
      <!--<div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <div class="card">


            <div class="card-header wh-header border-bottom padding-bottom-0px">
              <div class="row border-bottom">
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Discount : </label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Discount(%) :</label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Total :</label>
                </div>
              </div>
            </div>






          </div>
        </div>
      </div>-->




    </div>
  </div>




</div>
